<template>
  <div>
    <el-drawer :title="`【${info.courseName}】视频管理`" :visible.sync="drawerVisible" size="50%">
      <template>
        <div style="padding: 0 10px;">
          <el-form :model="search" label-width="80px">
            <el-row :gutter="20">
              <el-col :span="9">
                <el-form-item label="视频名称">
                  <el-input v-model="search.courseName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="分类名称">
                  <el-input v-model="search.chapterName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" @click="getList()">查询</el-button>
                <el-button @click="reSearch()">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-button type="primary" @click="dialogVisible = true">新增视频</el-button>
          <el-table :data="tableData" border style="margin-top: 10px;">
            <el-table-column prop="chapterName" label="视频名称" />
            <el-table-column prop="categoryName" label="分类" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="previewItem(scope.row.videoUrl)">预览</el-button>
                <el-button type="text" @click="editItem(scope.row)" style="margin-right: 10px;">编辑</el-button>
                <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.chapterId)">
                  <template #reference>
                    <el-button type="text" size="small">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="search.current" :page-size="search.size" layout="total, sizes, prev, pager, next"
            :total="totalNum" background />
        </div>
      </template>
    </el-drawer>

    <el-dialog :visible.sync="dialogVisible" :title="form.chapterId ? '编辑视频' : '新增视频'" width="500px"
      :close-on-click-modal="false" append-to-body>
      <el-form :model="form" label-width="80px" label-position="right">
        <el-form-item label="视频名称:">
          <el-input v-model="form.chapterName" placeholder="请输入视频名称"></el-input>
        </el-form-item>
        <el-form-item label="视频分类:">
          <el-select v-model="form.categoryId" filterable placeholder="请选择视频分类" style="width: 100%;">
            <el-option v-for="item in categoryList" :key="item.categoryId" :label="item.categoryName"
              :value="item.categoryId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频文件:">
          <uploadFiles v-model="form.videoUrl" accept=".mp4" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveItem">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import uploadFiles from '@/components/upload-files/upload-files.vue';
export default {
  components: {
    uploadFiles
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.form = {}
      }
    }
  },
  data() {
    return {
      drawerVisible: false,
      info: {},
      courseId: null,
      tableData: [],
      totalNum: 0,
      search: {
        current: 1,
        size: 20
      },
      categoryList: [],
      dialogVisible: false,
      form: {},
    }
  },
  methods: {
    open(info) {
      this.info = info
      this.courseId = info.id
      this.getList()
      this.getCategoryList()
      this.drawerVisible = true
    },
    async getCategoryList() {
      const res = await this.$request.get("/cms/courseChapters/getChapterList?courseId=" + this.courseId)
      if (res.data.code === 200) {
        this.categoryList = res.data.data || []
      }
    },
    async getList() {
      const res = await this.$request.post("/cms/courseChapters/getChapterDetail", {
        ...this.search,
        courseId: this.courseId,
      })
      if (res.data.code == 200) {
        this.tableData = res.data.data.records
        this.totalNum = res.data.data.total
      }
    },
    reSearch() {
      this.search = {
        current: this.search.current,
        size: this.search.size
      }
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.search.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.search.current = val
      this.getList()
    },
    editItem(row) {
      this.form = this.$deepClone(row)
      this.dialogVisible = true
    },
    async saveItem() {
      if (!this.form.chapterName || !this.form.videoUrl || !this.form.categoryId) {
        this.$message.warning('请填写完整信息！')
        return
      }
      const res = await this.$request.post("/cms/courseChapters/updateVideoDetail", {
        ...this.form,
        courseId: this.courseId
      })
      if (res.data.code === 200) {
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.getList()
      }
    },
    async deleteItem(id) {
      const res = await this.$request.get("/cms/courseChapters/deleteVideo?videoId=" + id)
      if (res.data.code === 200) {
        this.$message.success('删除成功')
        this.getList()
      }
    },
    async previewItem(url) {
      window.open(url, '_blank')
    }
  },
};
</script>